
import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { KryptonElement } from './krypton-element';
export class KryptonDialog extends KryptonElement {
    private kryptonDialogModal: any = undefined;
    static get styles() {
        return css`
          .krypton-dialog {
            color: black;
          }
        `
    }
    private config: any = {
        alert: {
            title: "Attention",
            cssClass: "krypton-alert",
            btnOkText: "OK",
            btnOkCssClass: "button"
        },
        confirm: {
            title: "Confirm",
            cssClass: "krypton-confirm",
            btnOkText: "OK",
            btnOkCssClass: "button",
            btnCancelText: "Cancel",
            btnCancelCssClass: "button button-clear"
        }
    };
    private _options: any = '';
    get options(): Object {
        return this._options;
    }

    @property({ type: Object })
    set options(value: Object) {
        const oldValue = this._options;
        this._options = value;
        this.requestUpdate('options', oldValue);
    }

    /*    private _title: string = '';
        @property({ type: String })
        get title(): string {
            return this._title;
        }

        set title(value: string) {
            const oldValue = this._title;
            this._title = value;
            this.requestUpdate('title', oldValue);
        }

        private _message: string = '';
        @property({ type: String })
        get message(): string {
            return this._message;
        }

        set message(value: string) {
            const oldValue = this._message;
            this._message = value;
            this.requestUpdate('message', oldValue);
        }
    */

    getDialogPropertyValue(key: string) {
        let options: any = this.options;
        let isConfirm = options.isConfirm;
        return options[key] || this.config[isConfirm ? "confirm" : "alert"][key];
    }

    async showModal(options: any) {
        options = options || {}
        options.url = options.url || options.data?.pageToLoad;
        this.options = options;
        let mdlDialog = document.querySelector('#staticBackdrop') || this.shadowRoot?.querySelector("#staticBackdrop");
        this.kryptonDialogModal = new window["bootstrap"].Modal(mdlDialog, {});
        document.querySelector(".modal-backdrop")?.remove();
        this.kryptonDialogModal?.show();
        if (options.url) {
            const response = await fetch(options.url),
                responseText = await response.text();
            let container = document.querySelector('#url-content') || this.querySelector('#url-content') || this.shadowRoot?.querySelector("#url-content");
            if (container) {
                container.innerHTML = "";
                container.appendChild(this.getContentHtml(responseText));
            }
        }
    }

    close() {
        this.hideModal(null);
    }

    hideModal(e) {
        let options: any = this.options;
        options && options.noCallBack && options.noCallBack();
        this.kryptonDialogModal?.hide();
        this.removeOverflowHidden();
    }
    okClicked(e) {
        let options: any = this.options;
        options && options.yesCallBack && options.yesCallBack();
        this.kryptonDialogModal?.hide();
        this.removeOverflowHidden();
    }
    removeOverflowHidden(){
        setTimeout(()=>document?.querySelector("body")?.style.removeProperty("overflow"),500);
    }

    getCloseButtonClass() {
        return this.options && this.options["isConfirm"] ? "d-none" : "btn-close";
    }
    getContentFromUrl() {
        let options: any = this.options;
        if (options && options.url) {
            return html`<div id='url-content'><img src="/images/loading.gif" style="padding-left:46%"></img></div>`;
        } else {
            return html`<div class="modal-body bootstrap-dialog-body">${unsafeHTML(this.getDialogPropertyValue("message"))}</div>`;
        }
    }
    onClickButton(btn) {
        if (btn && btn.action) {
            btn.action(this);
        }
    }
    renderButtons() {
        let options: any = this.options;
        if (options && options.buttons && options.buttons.length) {
            return html`${options.buttons.map(
                (btn, index) => html`<button class="button ${btn.cssClass}" @click="${(e: Event) => this.onClickButton(btn)}">${btn.label}</button>`
            )}`;
        }
        else {
            return html`
                ${options.isConfirm ? html`<button type="button" class="${this.getDialogPropertyValue('btnCancelCssClass')}" @click="${(e: Event) => this.hideModal(e)}">${this.getDialogPropertyValue("btnCancelText")}</button>` : html``}
                <button type="button" class="${this.getDialogPropertyValue('btnOkCssClass')}" @click="${(e: Event) => this.okClicked(e)}">${this.getDialogPropertyValue("btnOkText")}</button>
            `;
        }
    }
    renderWarningImage() {
        let options: any = this.options;
        if (options && options.showWarning === false) {
            return html``;
        }
        else {
            return html`<img src='/resources/images/icons/Orange_Warning.svg' class="pt-1"/>`;
        }
    }
    render() {
        return html`
            <link rel="stylesheet" href="/resources/styles/krypton-nextgen.css">
            <div id="krypton-dialog" class="${this.getDialogPropertyValue('cssClass')}">
                <!-- Modal -->
                <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog" id="instance">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">${unsafeHTML(this.getDialogPropertyValue("title"))}</h5>
                            <button type="button" class="${this.getCloseButtonClass()}" @click="${(e: Event) => this.hideModal(e)}" aria-label="Close"></button>
                        </div>
                        <div class="bootstrap-dialog-body d-table-row">
                            <div class="d-table-cell ps-3 pe-0">${this.renderWarningImage()}</div>
                            <div class="d-table-cell">${this.getContentFromUrl()}</div>
                        </div>
                        <div class="modal-footer">
                            ${this.renderButtons()}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'krypton-dialog': KryptonDialog;
    }
}
